import React from 'react';
// Importação de ícones de `react-icons` para o coração e as atividades
import { FaHeart, FaGamepad, FaPaintBrush, FaMusic, FaUserFriends } from 'react-icons/fa';

// Componente para os Detalhes do Programa (Frequência, Duração, etc.)
const ProgramDetailItem = ({ title, description }) => (
  <div className="mb-2">
    <span className="font-semibold">{title}:</span>{' '}
    <span className="text-sm">{description}</span>
  </div>
);

// Componente para o Bloco de Atividade (similar aos cards de passos, mas com ícone)
const ActivityBlock = ({ icon: Icon, title, description }) => (
  <div className={`bg-primary p-6 rounded-xl shadow-md text-white flex flex-col items-start`}>
    <div className="flex items-center mb-3">
        <Icon className="w-6 h-6 mr-3 text-third flex-shrink-0" />
        <h3 className="text-xl font-bold">{title}</h3>
    </div>
    <p className="text-gray-100 leading-relaxed text-sm">
      {description}
    </p>
  </div>
);


// Componente Principal
function CasaDeRepouso() {

  return (
    // Container Principal
    <div className="min-h-screen lg:pt-20 bg-gray-50">

      {/* Seção 1: Cabeçalho (Azul Escuro) */}
      <header className={`bg-primary pt-10 pb-20 px-4 md:px-8 text-white text-center`}>
        <div className="max-w-4xl mx-auto">
          
          {/* Ícone do Coração */}
          <div className="mb-6">
            <FaHeart className={`w-16 h-16 mx-auto text-third`} />
          </div>

          <h1 className="text-4xl md:text-5xl font-extrabold mb-2">
            Casa de Repouso
          </h1>
          <p className="text-lg md:text-xl px-4">
            Atividades recreativas e companhia para qualidade de vida dos idosos.
          </p>
        </div>
      </header>

      {/* Seção Principal de Conteúdo */}
      <main className="max-w-6xl mx-auto -mt-12 px-4 md:px-8">
        
        {/* Bloco de Informações - Sobre o Programa (Divisão em 2 colunas) */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">

          {/* Coluna 1: Sobre o Programa - Texto Longo (Fundo Branco) */}
          <div className={`bg-white p-8 rounded-xl shadow-lg border-t-4 border-primary`}>
            <h2 className={`text-2xl font-bold text-primary mb-4`}>
              Sobre o Programa
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              O programa Casa de Repouso oferece atividades recreativas, acompanhamento e companhia para idosos em casas de repouso e instituições similares.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Nossas atividades incluem jogos, conversas, artesanatos, música e momentos de convívio que promovem bem-estar e qualidade de vida.
            </p>
          </div>

          {/* Coluna 2: Sobre o Programa - Detalhes (Fundo Verde Água) */}
          <div className={`bg-third p-8 rounded-xl shadow-lg text-white`}>
            <h2 className="text-2xl font-bold mb-4">
              Sobre o Programa
            </h2>
            <ProgramDetailItem
              title="Frequência"
              description="Flexível (1-4 vezes por semanal)"
            />
            <ProgramDetailItem
              title="Duração"
              description="2-3 horas por visita"
            />
            <ProgramDetailItem
              title="Atividades"
              description="Jogos, arte, música e conversas"
            />
            <ProgramDetailItem
              title="Localização"
              description="Casas de repouso conveniadas"
            />
          </div>

        </div>

        {/* Seção 2: Atividades Oferecidas (4 Blocos) */}
        <section className="py-8">
          <h2 className={`text-3xl font-bold text-primary mb-8 text-center`}>
            Atividades Oferecidas
          </h2>
          {/* Cada atividade ocupa uma linha para simular os blocos longos */}
          <div className="space-y-4"> 
            
            <ActivityBlock
              icon={FaGamepad}
              title="Jogos e Diversão"
              description="Baralho, dominó, bingo e outros jogos tradicionais que promovem diversão e socialização."
            />

            <ActivityBlock
              icon={FaPaintBrush}
              title="Artesanato"
              description="Atividades criativas que estimulam a criatividade e a motricidade."
            />

            <ActivityBlock
              icon={FaMusic}
              title="Música"
              description="Momentos musicais que trazem alegria, memórias e bem-estar emocional."
            />
            
            <ActivityBlock
              icon={FaUserFriends}
              title="Companhia"
              description="Conversas, ouvir histórias e proporcionar momentos de conexão humana significativa."
            />

          </div>
        </section>

      </main>
      
      {/* Seção 3: CTA (Call to Action) */}
      <div className="text-center py-10 bg-gray-50">
        <p className={`text-2xl font-semibold text-primary mb-6`}>
          Pronto para se voluntariar?
        </p>
        <button
          className={`bg-fourth hover:bg-opacity-80 text-white font-bold py-3 px-8 rounded-full text-lg shadow-xl transition duration-300 ease-in-out transform hover:scale-105`}
          onClick={() => alert('Direcionando para a página de inscrição...')}
        >
          Inscreva-se
        </button>
      </div>

    </div>
  );
};

export default CasaDeRepouso;